import React, { useState } from "react";
import jackjaffalogo from "../../Assets/jackjaffalogo.png";
import "../../Style/home/SloganBanner.scss";
import { MdLocationOn } from "react-icons/md";
import {
  NotificationFilled,
  BuildFilled,
  MailFilled,
  CalendarFilled,
  FileTextFilled,
  PhoneFilled,
} from "@ant-design/icons";
import { Drawer, Modal, Tooltip } from "antd";
import { Dropdown, Menu } from "antd";
import { useNavigate } from "react-router";
import { IoIosMenu } from "react-icons/io";
import Order from "./SlogganBannerPages/Order";
function SloganBanner() {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const menu = (
    <Menu>
      <Menu.Item onClick={() => navigate("/client_view")}>Dashboard</Menu.Item>

      <Menu.Item onClick={showModal}>Order</Menu.Item>
      <Menu.Item onClick={() => navigate("/client_snapshot_generator_")}>
        Reporting
      </Menu.Item>
    </Menu>
  );
  const menuCharts = (
    <Menu>
      <Menu.Item onClick={() => navigate("/client_snapshot_generator_")}>
        Client Snapshot
      </Menu.Item>
      <Menu.Item onClick={() => navigate("/history_report_generator")}>
        History Reports
      </Menu.Item>

      <Menu.Item onClick={() => navigate("/record_view_charts")}>
        Clients Charts
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div className="rowheader">
        <div className="childofheader">
          <div className="header-left" onClick={() => navigate("/client_view")}>
            <img
              className="logo"
              style={{
                width: "100px",
                height: "100px",
                cursor: "pointer",
              }}
              src={jackjaffalogo}
              alt="Jack Jaffa and associations"
            />
          </div>
          <div className="signaturedesc">
            <div style={{ display: "flex", marginLeft: "1rem" }}>
              <MdLocationOn
                style={{
                  color: "#d39b6a",
                }}
              />
              <h4>Location</h4>
            </div>

            <div>
              <p>2380a Ralph Avenue</p>Brooklyn New York
              <br />
              11234, United States
            </div>
          </div>
          <div className="signaturecare">
            <div>
              <PhoneFilled
                style={{
                  margin: "-48px 0.6rem 0.6rem 0.6rem",
                  color: "#d39b6a",
                }}
              />
              <h4>Contact</h4>
            </div>
            <div>
              <p>Client Care: Sima Joudeh</p> +1 718 513 0775
              <a
                className="email-link"
                style={{
                  marginLeft: "5px",
                  display: "block",
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                href="mailto:info@stonecoreinc.com"
              >
                info@stonecoreinc.com
              </a>
            </div>
          </div>

          <div className="signatureicons" />
          <IoIosMenu className="icon-dawer" onClick={showDrawer} />
        </div>
      </div>
      <Drawer onClose={onClose} open={open}>
        <div className="drawer-main">
          <div className="signaturedesc" style={{ border: "px solid black" }}>
            <div
              style={{
                display: "flex",
                marginLeft: "1rem",
              }}
            >
              <MdLocationOn
                style={{
                  margin: "0.2rem 0.4rem 0.6rem 0.6rem",
                  color: "#d39b6a",
                }}
              />
              <h4>Location</h4>
            </div>

            <div>
              <p>2380a Ralph Avenue</p>Brooklyn New York
              <br />
              11234, United States
            </div>
          </div>
          <div className="signaturecare">
            <div>
              <PhoneFilled
                style={{
                  color: "#d39b6a",
                  marginLeft: "39px",
                }}
              />
              <h4
                style={{
                  marginLeft: "9px",
                }}
              >
                Contact
              </h4>
            </div>
            <div>
              <p>Client Care: Sime Jouden</p> +1 718 513 0775
              <a
                className="email-link"
                style={{
                  marginLeft: "5px",
                  display: "block",
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                href="mailto:info@stonecoreinc.com"
              >
                info@stonecoreinc.com
              </a>
            </div>
          </div>
          <div className="signatureicons">
            <NotificationFilled
              style={{ backgroundColor: "red" }}
              onClick={() => navigate("/client_view")}
            />
            <BuildFilled
              onClick={() => navigate("/record_view_BuildingQuickview")}
              style={{ backgroundColor: "#005CE6" }}
            />
            <Dropdown overlay={menu} trigger={["hover"]}>
              <MailFilled style={{ backgroundColor: "#D7D8D6" }} />
            </Dropdown>
            <CalendarFilled style={{ backgroundColor: "#FF9900" }} />
            <FileTextFilled style={{ backgroundColor: "#00CED1" }} />
          </div>
        </div>
      </Drawer>
      <Modal
        title={
          <span>
            <MailFilled style={{ margin: "10px 5px 0 0" }} />
            <span>ANNUAL SAFETY MAILINGS ~ SERVICE OPTIONS</span>
          </span>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
      >
        <Order />
      </Modal>
    </div>
  );
}

export default SloganBanner;
